import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import styled from "@rentiohq/web-theme";
import { RM_COLORS } from "../../rentmatch.colors";

/**
 * Candidacies came in on the tab the broker is already looking at (DEV-3272).
 *
 * An offer, not an event. Loading them by itself would push every row down by
 * one, and this screen sorts newest first, so a pointer resting on one
 * candidate's reject button would end up over another's. Nothing moves until
 * this is pressed, which is also why there is no machinery anywhere here to
 * work out whether the broker is mid-drag or has a modal open.
 *
 * Under the header row rather than over it, so the column titles stay where the
 * broker expects them and this reads as the top of the list.
 */
const Bar = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 10px 16px;
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.getColor("gray", 200)};
  background: ${RM_COLORS.blueBg};
  color: ${({ theme }) => theme.getColor("primary", "1000")};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 120ms ease;

  &:hover {
    background: ${RM_COLORS.blueBgAlt};
  }
`;

export const NewCandidaciesBar = (props: {
  count: number;
  onLoad: () => void;
}) => {
  const { count, onLoad } = props;

  if (count <= 0) {
    return null;
  }

  return (
    <Bar type="button" onClick={onLoad}>
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M21 12a9 9 0 1 1-2.64-6.36" />
        <polyline points="21 3 21 9 15 9" />
      </svg>
      {getLocalizedText(
        count === 1
          ? "applications.new_candidacies.load.one"
          : "applications.new_candidacies.load.many",
        { count: `${count}` },
      )}
    </Bar>
  );
};
